import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps } from 'react-router'
import AddTask from './Task/AddTask'
import EditTask from './Task/EditTask'
import GlobalTaskOverview from './Task/GlobalTaskOverview'
import TaskOverview, { TaskOverviewProps } from './Task/TaskOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'

type Props = EntityPageProps & {
    overviewProps?: Omit<TaskOverviewProps, 'baseUrl'>
}

export const taskBaseUrl = '/task'

export default function Tasks(props: Props): ReactElement {
    return (
        <EntityPage {...props} baseUrl={taskBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <>
                    <Route
                        exact
                        path={route}
                        render={(routeProps: RouteComponentProps) =>
                            route === taskBaseUrl ? (
                                <GlobalTaskOverview />
                            ) : (
                                <TaskOverview {...routeProps} {...props.overviewProps} baseUrl={baseUrl} />
                            )
                        }
                    />
                    <Route path={`${route}/add`}>
                        <AddTask returnUrl={baseUrl} useFileContext={props.useFileContext} />
                    </Route>
                    <Route path={`${route}/:id/edit`}>
                        <EditTask returnUrl={baseUrl} useFileContext={props.useFileContext} />
                    </Route>
                </>
            )}
        </EntityPage>
    )
}
